module.exports = __webpack_public_path__ + "static/img/3.40462bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pictures/five/3.png
// module id = kCTw
// module chunks = 1